import { render, staticRenderFns } from "./Flipcard.vue?vue&type=template&id=22ac169b&scoped=true&"
import script from "./Flipcard.vue?vue&type=script&lang=js&"
export * from "./Flipcard.vue?vue&type=script&lang=js&"
import style0 from "./Flipcard.vue?vue&type=style&index=0&id=22ac169b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac169b",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QCardActions,QBtn});
